import React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDropdown, FilterOptionType } from 'src/components/RealityCheckForm/CustomDropdown';
import { GamstopPreviouslyPositiveState } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.state';
import {
    GAMSTOP_PP_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY,
    GAMSTOP_PP_DEPOSIT_RESTRICTION_OPTIONS_ARRAY,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositiveRestrictionOptions';
import {
    GamstopPreviouslyPositiveRestrictionPeriodField,
    GamstopPreviouslyPositiveRestrictionPeriodFieldLabel,
    GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositiveRestrictionPeriodPanel.style';

interface GamstopPreviouslyPositiveComplianceRestrictionPeriodPanelPropsType {
    state: GamstopPreviouslyPositiveState;
}

export const GamstopPreviouslyPositiveComplianceRestrictionPeriodPanel = observer(
    ({ state }: GamstopPreviouslyPositiveComplianceRestrictionPeriodPanelPropsType): JSX.Element => {
        return (
            <GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper data-test='gamstop-pp-compliance-restriction-period-panel'>
                <GamstopPreviouslyPositiveRestrictionPeriodField>
                    <GamstopPreviouslyPositiveRestrictionPeriodFieldLabel>
                        Restriction period
                    </GamstopPreviouslyPositiveRestrictionPeriodFieldLabel>
                    <CustomDropdown
                        dataTest='gamstop-pp-compliance-restriction-period'
                        hasInternalLabel={false}
                        onChangeCallback={state.onUpdateComplianceRestrictionPeriod}
                        optionsList={(): Array<FilterOptionType<string>> =>
                            GAMSTOP_PP_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY
                        }
                        placeholder='Select period'
                        selectedValue={(): string | null => state.complianceRestrictionPeriod}
                    />
                </GamstopPreviouslyPositiveRestrictionPeriodField>
            </GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper>
        );
    }
);

interface GamstopPreviouslyPositiveDepositRestrictionPeriodPanelPropsType {
    state: GamstopPreviouslyPositiveState;
}

export const GamstopPreviouslyPositiveDepositRestrictionPeriodPanel = observer(
    ({ state }: GamstopPreviouslyPositiveDepositRestrictionPeriodPanelPropsType): JSX.Element => {
        return (
            <GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper data-test='gamstop-pp-deposit-restriction-period-panel'>
                <GamstopPreviouslyPositiveRestrictionPeriodField>
                    <GamstopPreviouslyPositiveRestrictionPeriodFieldLabel>
                        Restriction period
                    </GamstopPreviouslyPositiveRestrictionPeriodFieldLabel>
                    <CustomDropdown
                        dataTest='gamstop-pp-deposit-restriction-period'
                        hasInternalLabel={false}
                        onChangeCallback={state.onUpdateDepositRestrictionPeriod}
                        optionsList={(): Array<FilterOptionType<number | null>> =>
                            GAMSTOP_PP_DEPOSIT_RESTRICTION_OPTIONS_ARRAY
                        }
                        placeholder='Select period'
                        selectedValue={(): number | null => state.depositRestrictionPeriod}
                    />
                </GamstopPreviouslyPositiveRestrictionPeriodField>
            </GamstopPreviouslyPositiveRestrictionPeriodPanelWrapper>
        );
    }
);
